import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ProductService from '../../services/ProductService';
import moment from "moment";
import { showLoading } from 'react-global-loading';
import CountryHeader from "./CountryHeader";

export const userData = localStorage.getItem('persist:root') ?
  JSON.parse(JSON.parse(localStorage.getItem('persist:root')).userData) : '';

const CountryProducts = (props) => {
  const [countryId, setCountryId] = useState(props.match.params.id);
  const [categoryId, setCategoryId] = useState(props.match.params.catId);
  const [productsList, setProductsList] = useState([]);

  useEffect(() => {
    showLoading(false);
    getProductList();
  }, []);

  const getProductList = () => {
    ProductService.getAllProductByCountry({ 'blog_id': countryId, 'category': categoryId }).then((result) => {
      if (!result) {
        return;
      }
      setProductsList(result);
      showLoading(false);
    })
      .catch((err) => {
        console.error(err);
      });
  };
  const handleCallback = (childData) => {

    setCategoryId(childData.id)
  };
  return (
    <div className="container pt-2">
      <CountryHeader parentCallback={handleCallback} category={categoryId} country={countryId} />
      <div className="row bg-light p-2 pt-4 mt-5 mb-3 rounded rounded-2">
        <div className="col-12">
          <h3 className="mb-3">Products</h3>
          <div className="row view-group" id="products2">
            {/* below is the product card */}
            {productsList.length > 0 ? productsList.map((item, index) =>
              <div key={index} className="col-md-3 mb-3">
                <div className="card p-3 event-card crdev">
                  <div className="imgrel">
                    <Link to={{
                      pathname: "/country-product-details",
                      search: `?id=${item.ID}`,
                      state: { productDetails: item }
                    }}>
                      <img src={item.product_image} className="card-img-top rounded" style={{ height: '150px', objectFit: 'cover' }} />
                    </Link>
                  </div>
                  <div className="evtxcn px-0">
                    <h4 className="evh">
                      <Link to={"/country-product-details?id=" + item.ID} className="evhd crop-text">{item.post_title}</Link>
                    </h4>
                    <span className="muted d-block mt-1 doccell crop-text">{item.post_title}</span>
                    <p className="evdes_nw">{item.post_content}</p>
                  </div>
                </div>
                <div className="crbotm">
                  <p className="dtpr">Created - <span className="cdte">{moment(item.post_date).format("Do MMM YYYY")}</span></p>
                  <span className="dtpr">/</span>
                  <p className="dtpr">{` Last Updated On - `}<span className="cdte">{moment(item.post_modified).format("Do MMM YYYY")}</span></p>
                </div>
              </div>
            ) : <div className="col-12 mb-4">
              <div class="alert alert-success" role="alert">
                <h4 class="alert-heading">
                  <i class="fa fa-exclamation-circle me-1" aria-hidden="true"></i> Data Not Found!
                </h4>
                <p>We regret to inform you that the requested data could not be located or does not exist in our records. It is possible that the information you are seeking has not been documented, is not publicly available, or has been removed or archived.</p>
              </div>
            </div>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountryProducts;
